<template>
    <m-card204 class="" :image="content.thumbnail" :alt="content.title">
        <p class="m-0 p-0 content-card-title content-card-color font-weight-bolder">{{ content.title }}</p>
    </m-card204>
</template>

<script>
import mCard204 from "../../Cards/Card204";
import mImg from '../../Tags/Img'

export default {
    name: "ContentCard204",
    props: {
        content: {}
    },
    components: {mCard204, mImg}
}
</script>

<style scoped>


</style>